import { formatTimestamp } from '@/shared/utils/format';
import styles from './SectionLabel.module.css';
import patterns from '../styles/patterns.module.css';

interface SectionLabelProps {
  label: string;
  sub?: string;
  timestamp?: string | Date | null;
}

export function SectionLabel({ label, sub, timestamp }: SectionLabelProps) {
  return (
    <div className={styles.root}>
      <div className={styles.label}>{label}</div>
      {sub && <div className={styles.sub}>{sub}</div>}
      {timestamp && (
        <p className={patterns.timestamp}>Last updated: {formatTimestamp(timestamp)}</p>
      )}
    </div>
  );
}
